import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { UserProfile } from "@ui/internal/components/card";
import { ZoomImage } from "@ui/internal/components/formelement";
import { isNullCheck } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { Star } from "lucide-react";
import { useMemo } from "react";
interface CloumnListProps {
  refetch?: () => void;
}
const ColumnList = ({ refetch }: CloumnListProps) => {
  const journeyEndpoint = useMemo(() => endpoint["journey"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: journeyEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },
      {
        name: <span className="flex items-center gap-2">Name</span>,
        accessKey: "image",

        cell: (row: any) => (
          <div className="flex items-center gap-4">
            {row?.is_superuser && (
              <div className=" flex items-center justify-center">
                <Star className="h-[12px] w-[12px] outline-1 rounded-full outline-offset-4 outline-yellow-400 text-yellow-400" />
              </div>
            )}
            <UserProfile
              userimage={row?.image || NoImage}
              username={row.full_name}
            />
          </div>
        ),
        sortable: false,
      },

      {
        name: "Designation",

        cell: (row: any) => (
          <Tooltip description={isNullCheck(row.designation?.name) as string}>
            <div className="flex justify-start text-gray-800">
              <span className="text-start w-fit max-w-[150px] truncate">
                {isNullCheck(row.designation?.name) as string}
              </span>
            </div>
          </Tooltip>
        ),
        sortable: true,
      },
      {
        name: "Role",

        cell: (row: any) => (
          <>
            {row?.roles.length > 0 ? (
              <Tooltip
                description={row.roles
                  ?.map((item: { name: string }) => item.name)
                  .join(",")}
              >
                <div className="flex justify-start text-gray-800">
                  <span className="text-start w-fit max-w-[150px] truncate">
                    {row?.roles
                      ?.slice(0, 2)
                      .map((role: { name: string }) => role?.name)
                      .join(", ")}
                    {row?.roles?.length > 2
                      ? ` +${row.roles.length - 2} more`
                      : ""}
                  </span>
                </div>
              </Tooltip>
            ) : (
              "N/A"
            )}
          </>
        ),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "modal-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                // clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };
